import { normalize, schema } from 'normalizr';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const ENTRIES_LIST_SUCCESS = api.events.entriesList.actionSuccess;
const ENTRIES_CREATE_SUCCESS = api.events.entriesCreate.actionSuccess;
const ENTRIES_PATCH_SUCCESS = api.events.entriesPatch.actionSuccess;

const entrySchema = new schema.Entity('entries');
const entriesSchema = new schema.Array(entrySchema);

const defaultState = { all: [] };

export default function(state = defaultState, action) {
  switch (action.type) {
    case ENTRIES_CREATE_SUCCESS:
    case ENTRIES_PATCH_SUCCESS: {
      const normalizedData = normalize(action.data, entrySchema);
      return {
        all: { ...state.all, ...normalizedData.entities.entries }
      };
    }

    case ENTRIES_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, entriesSchema);
      return { all: normalizedData.entities.entries };
    }

    case LOGOUT_SUCCESS:
      return defaultState;

    default:
      return state;
  }
}
